export default "__VITE_ASSET__CGro3k9K__"